export interface Session {
  isInitialized: boolean;
  isLoggedIn: boolean;
  isAdmin: boolean;
}

export type Access = { kind: 'allow' } | { kind: 'redirect'; to: string };

const ALLOW: Access = { kind: 'allow' };
const redirect = (to: string): Access => ({ kind: 'redirect', to });

// Reachable without a session. /logout is here deliberately: a logged-in Player has to be
// able to get to it, and a logged-out one landing there should not bounce.
const PUBLIC_PATHS = ['/login', '/logout', '/register'];

const ADMIN_ROOT = '/admin';

const normalise = (path: string): string => {
  const trimmed = path.replace(/\/+$/, '');
  return trimmed === '' ? '/' : trimmed;
};

// Exact segment match. The old check was `path.match('/admin')`, which matched any path
// merely containing the word.
export const isAdminPath = (path: string): boolean => {
  const p = normalise(path);
  return p === ADMIN_ROOT || p.startsWith(`${ADMIN_ROOT}/`);
};

export const isPublicPath = (path: string): boolean => PUBLIC_PATHS.includes(normalise(path));

export function access(path: string, session: Session): Access {
  if (!session.isInitialized) {
    return ALLOW;
  }
  if (isAdminPath(path) && !session.isAdmin) {
    return redirect(session.isLoggedIn ? '/' : '/login');
  }
  if (!session.isLoggedIn) {
    return isPublicPath(path) ? ALLOW : redirect('/login');
  }
  // Logging out is the one public path a logged-in Player still needs.
  if (isPublicPath(path) && normalise(path) !== '/logout') {
    return redirect('/');
  }
  return ALLOW;
}
